<div class="pt-2">
  <app-info-text text="PLAYER_PROFILE_CHANGE_BIRTHDAY_MSG" color="text-frontend-accent-gray"/>
  <div class="pt-3 flex">
    <app-common-date [(date)]="birthday" [showIcon]="true"/>
  </div>
</div>

<div class="flex justify-content-end pt-3">
  <app-dialog-button [loading]="isSaving"
                     [okButtonDisabled]="!birthday"
                     (onOkClicked)="onOkClicked()"
                     (onCancelClicked)="onCancelClicked()"/>
</div>
